module.exports = __webpack_public_path__ + "img/pic7.53b3f69b.png";